module.exports = __webpack_public_path__ + "static/media/gov-site-device-rego.08cbe1fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/providers-registrations/onboarding/device-registration/views/gov-site-device-rego.svg
// module id = 1041
// module chunks = 0